// src/components/Letreiro.jsx
import React from 'react';
import logo from '@/assets/logo.png'; // ajuste o caminho se necessário
import { motion } from 'framer-motion';

const Letreiro = () => {
  return (
    <div className="w-full overflow-hidden bg-gradient-to-r from-[#3b2e2e] via-[#4b3a2e] to-[#3b2e2e] py-3 px-4 rounded-md shadow-md mt-6 border-2 border-[#C9AA7B]">
      <motion.div
        className="flex items-center gap-4 text-[#C9AA7B] font-medium text-sm md:text-base"
        initial={{ x: '100%' }}
        animate={{ x: '-100%' }}
        transition={{ duration: 18, repeat: Infinity, ease: 'linear' }}
      >
        <img src={logo} alt="Logo" className="h-8 md:h-10 object-contain drop-shadow-lg" />
        <span className="whitespace-nowrap">
          Atendemos em IPATINGA, CORONEL FABRICIANO, TIMÓTEO e em outras localidades do Vale do Aço — Para mais informações, entre em contato!
        </span>
      </motion.div>
    </div>
  );
};

export default Letreiro;
